/**
 * Shared payment submission handler for processing payments and pledges
 */

import { postPledge, postPayment } from './index';
import { devLog } from './helpers';
import { triggerConversionEvent } from './paymentHelpers';

/**
 * Handle credit card submission for payment or pledge
 * @param {Object} params - Parameters object
 * @param {Object} params.state - Current component state
 * @param {Object} params.creditCardPayment - Credit card payment data from form
 * @param {Function} params.onSuccess - Callback on successful payment/pledge
 * @param {Function} params.onError - Callback on error
 * @param {string} params.pageType - Page type for conversion tracking (homeowner, renter, business, etc.)
 * @returns {Promise<void>}
 */
export const handlePaymentSubmission = async ({
  state,
  creditCardPayment,
  onSuccess,
  onError,
  pageType
}) => {
  const { mode, ...payment } = state;
  
  // Add credit card details to payment
  payment['name'] = creditCardPayment?.name || '';
  payment['postalCode'] = creditCardPayment?.postalCode || '';
  payment['phone'] = creditCardPayment?.phone || '';

  devLog("Payment data prepared:", payment);

  try {
    if (!creditCardPayment?.pledgeOnly) {
      // Process payment through Stripe
      devLog("Posting payment");
      await postPayment(payment);
      triggerConversionEvent(pageType);
      onSuccess();
    } else {
      // Process pledge
      devLog("Posting pledge");
      await postPledge(payment);
      triggerConversionEvent(pageType);
      onSuccess();
    }
  } catch (error) {
    devLog(`Error processing ${creditCardPayment?.pledgeOnly ? 'pledge' : 'payment'}:`, error);
    onError(creditCardPayment?.pledgeOnly ? `Pledge status: ${error.message}` : error.message);
  }
};
